import { render } from "./RecaptchaIntegrationSettings.vue?vue&type=template&id=34157315"
import script from "./RecaptchaIntegrationSettings.vue?vue&type=script&lang=js"
export * from "./RecaptchaIntegrationSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__